//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Slider from "react-slick";


const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    const searchCategories = [
        {
            text: t('homePage.searchForTypo.typology2Text'),
            imgPath: "/assets/images/inHome/tipologie/villa.webp",
            link: "immobili/villa"
        },
        {
            text: t('homePage.searchForTypo.typology5Text'),
            imgPath: "/assets/images/inHome/tipologie/villa-piscina.webp",
            link: "immobili/villa?piscina=true"
        },
        {
            text: t('homePage.searchForTypo.typology1Text'),
            imgPath: "/assets/images/inHome/tipologie/appartamento.webp",
            link: "immobili/appartamento"
        },
        
        {
            text: t('homePage.searchForTypo.typology3Text'),
            imgPath: "/assets/images/inHome/tipologie/casale.webp",
            link: "immobili/casale"
        },
        {
            text: t('homePage.searchForTypo.typology4Text'),
            imgPath: "/assets/images/inHome/tipologie/bifamiliare.webp",
            link: "immobili/villetta-bifamiliare"
        },
        
        {
            text: t('homePage.searchForTypo.typology6Text'),
            imgPath: "/assets/images/inHome/tipologie/commerciale.webp",
            link: "immobili/attivita-commerciale"
        }
    ]

    const settings = {
        dots: true,
        arrows:false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 4000,
    };
        
    return(
        <section id = "searchForTipology" className = "space-ptb" >
                <div className="container-fluid w-special">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-4 order-lg-2">
                            <h3>{t('homePage.searchForTypo.subTitle')}</h3>
                            <h2>{t('homePage.searchForTypo.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.searchForTypo.para') as string }}></p>
                        </div>
                        <div className="col-12 col-lg-8 order-lg-1">
                            <Slider {...settings}>
                                {searchCategories.map((category, index) => (
                                    <div key={index}>
                                        <Link to={category.link} className="category-card" title={category.text} >
                                            <img src={category.imgPath} className="img-fluid" alt={`${t('homePage.searchForTypo.altIntro') + category.text}`} />
                                            <h4 className="text-center m-0">{category.text}</h4>
                                            <div className="circle-shadow"></div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
        </section >
    );
}

export default TipologySearchSection;
